export class TokenStore {
    static createInMemory() {
        return new InMemoryTokenStore();
    }
    static createSessionStorage() {
        return new SessionStorageTokenStore();
    }
    static createLocalStorage() {
        return new LocalStorageTokenStore();
    }
}
class InMemoryTokenStore extends TokenStore {
    constructor() {
        super(...arguments);
        this.tokens = {};
    }
    get(subject) {
        var _a;
        return (_a = this.tokens[subject.toString()]) !== null && _a !== void 0 ? _a : null;
    }
    save(subject, token) {
        this.tokens[subject.toString()] = token;
        return token;
    }
    delete(subject) {
        delete this.tokens[subject.toString()];
    }
}
class SessionStorageTokenStore extends TokenStore {
    get(subject) {
        const key = createStorageKey(subject.toString());
        return sessionStorage.getItem(key);
    }
    delete(subject) {
        const key = createStorageKey(subject.toString());
        sessionStorage.removeItem(key);
    }
    save(subject, token) {
        sessionStorage.setItem(createStorageKey(subject.toString()), token);
        return token;
    }
}
class LocalStorageTokenStore extends TokenStore {
    get(subject) {
        const key = createStorageKey(subject.toString());
        return localStorage.getItem(key);
    }
    save(subject, token) {
        localStorage.setItem(createStorageKey(subject.toString()), token);
        return token;
    }
    delete(subject) {
        localStorage.removeItem(createStorageKey(subject.toString()));
    }
}
const storageTokenKeyPrefix = 'dialect-auth-token';
function createStorageKey(subject) {
    return `${storageTokenKeyPrefix}-${subject}`;
}
//# sourceMappingURL=token-store.js.map